import styled from 'styled-components'

export const EditorComponent = styled.div`
`